/*----------------------------------
- PRODUCT FEATURE TABS (SSOT)
----------------------------------*/

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import type { ProductFeatureSlug } from '@/client/catalogs/landing/product/types';
import { LANDING_WEBSITE_PAGE_ROUTES } from '@/common/catalogs/landing/publicPages';

/*----------------------------------
- TYPES
----------------------------------*/

export type ProductFeatureTab = {
    slug: ProductFeatureSlug;
    label: string;
    href: string;
};

/*----------------------------------
- CATALOG
----------------------------------*/

/**
 * The hero segmented control of the five feature pages.
 *
 * They are five real routes, so the tabs are links: no client state, no JS, and a
 * crawler reads the sibling features from them. `/product/appraise` is
 * deliberately absent: it is its own page design, not a member of this template.
 */
export const PRODUCT_FEATURE_TABS: readonly ProductFeatureTab[] = [
    { slug: 'search', label: 'Search', href: LANDING_WEBSITE_PAGE_ROUTES.productSearch },
    { slug: 'verify', label: 'Verify', href: LANDING_WEBSITE_PAGE_ROUTES.productVerify },
    { slug: 'radars', label: 'Radars', href: LANDING_WEBSITE_PAGE_ROUTES.productRadars },
    { slug: 'watchlists', label: 'Watchlists', href: LANDING_WEBSITE_PAGE_ROUTES.productWatchlists },
];
